import { GET, POST, PUT } from "./_config";

//user
export const getEducationalResourcesData = async (query) =>
  await GET(`/educational_resources?${query || ""}`);

export const getEducationalDataById = async (id) =>
  await GET(`/educational_resources/get-educational-resource/${id}`);

//admin
export const getEducationDataList = async (query) =>
  await GET(`/educational_resources/list?${query || ""}`, true);

export const deleteEducationDataById = async (body) =>
  await POST("/educational_resources/delete", body, true);

export const updateEducationStatus = async (body) =>
  await POST("/educational_resources/update-status", body, true);

export const createEducationData = async (body) =>
  await POST("/educational_resources", body, true);

export const getEducationDataById = async (id) =>
  await GET(`/educational_resources/${id}`, true);

export const updateEducationDataById = async (id, body) =>
  await PUT(`/educational_resources?id=${id}`, body, true);

export const updateEducationalResourceSortOrders = async (payload) =>
  await PUT("educational_resources/sort-order", { sortOrders: payload }, true);
